import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import TabPage from "./../../factories/tab-page";
import FrequencyDistributionCategoryModuleDiagramViewModel from "./frequency-distribution-category-module-diagram-view-model";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
import * as d3 from "d3";

function FrequencyDistributionCategoryReportViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ReportLoaded = ko.observable(false);
    self.Limit = ko.observable(10);
    self.Models = ko.observableArray([]);
    self.AllModels = ko.observableArray([]);
    self.PageIndexDefault = 0;
    self.PageSizeDefault = 10;
    self.PageIndex = ko.observable(self.PageIndexDefault);
    self.PageSize = ko.observable(self.PageSizeDefault);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observable([]);
    self.chart = ko.observable();
    self.IsLoading = ko.observable();
    self.EndDateTime = ko.observable();
    self.StartDateTime = ko.observable();
    self.checker1 = self.EndDateTime();
    self.checker2 = self.StartDateTime();
    self.ViewModel = ko.observable();
    self.CaptionDatasieriesname = ko.observable("data1");
    self.chart = ko.observable();
    self.chartColors = [];
    self.DiagramDataSet = ko.pureComputed(function () {
        var entries = self.AllModels();
        var data = {
            x: "x",
            columns: [["data1"], ["x"]],
            types: {
                data1: "bar"
            },
            names: {
                data1: self.CaptionDatasieriesname()
            },
            labels: true,
            color: function (color, d) {
                if (d.index != null && self.chartColors != null) {
                    return self.chartColors[d.index];
                }
                return "#1f77b4";
            }
        };
        if (entries.length > 0) {
            for (var i in entries) {
                var y = ko.unwrap(entries[i].NumberOfEvents);
                if (typeof y === "undefined" || y === null) {
                    y = 0;
                }
                data.columns[0].push(y);
                var label = ko.unwrap(entries[i].CategoryFullName);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                data.columns[1].push(label);
                var color = ko.unwrap(entries[i].ColorString);
                if (typeof color === "undefined" || color == null) {
                    color = "#1f77b4";
                }
                self.chartColors.push(color);
            }
        }
        return data;
    });
    self.cDreiChartBinding = ko.observable({
        data: self.DiagramDataSet,
        legend: {
            show: false
        },
        axis: {
            x: {
                type: "category",
                tick: {
                    rotate: 75,
                    multiline: false
                }
            },
            y: {
                tick: {
                    format: function (x) {
                        if (x % 1 > 0) {
                            var tick = d3.selectAll(".c3-axis-y g.tick").filter(function () {
                                var text = d3.select(this).select("text").text();
                                return +text === x;
                            }).style("opacity", 0);
                            return "";
                        }
                        else {
                            return x;
                        }
                    }
                }
            },
            rotated: true
        },
        tooltip: {
            show: false,
            contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
                return "<span>123abc</span>";
            }
        }
    });
    self.IsReportResultEmpty = ko.pureComputed(function () {
        return Boolean(self.ReportLoaded() && typeof self.Models() !== "undefined" && self.Models().length === 0);
    });
    self.GetFrequencyDistributionCategoryReportResult = function (sorting, pageIndex, pageSize, saveFilter) {
        var propertyNames = ["StartDateTime", "EndDateTime", "Limit"];
        var filter = self.GetFilterHashObject(propertyNames, self);
        return Bao.post("ReportCenter/FrequencyDistributionCategoryGetReportResult", JSON.stringify({
            filter: filter,
            sorting: sorting,
            pageIndex: pageIndex,
            pageSize: pageSize
        }));
    };
    self.GetFilterHashObject = function (propertyNames, viewModel, keyAliases) {
        var filterObject = [];
        if (typeof keyAliases === "undefined" || keyAliases === null || propertyNames.length !== keyAliases.length) {
            keyAliases = propertyNames;
        }
        for (var i in propertyNames) {
            if (typeof viewModel[propertyNames[i]] !== "undefined") {
                filterObject.push({
                    Key: keyAliases[i],
                    Value: ko.unwrap(viewModel[propertyNames[i]])
                });
            }
        }
        return filterObject;
    };
    self.RefreshModels = function () {
        return self.GetFrequencyDistributionCategoryReportResult(self.Sorting(), self.PageIndex(), self.PageSize(), true).done(function (result) {
            if (result.Result == true) {
                self.Models(result.Models);
                self.TotalRows(result.TotalRows);
            }
        });
    };
    self.RefreshDiagramModels = function () {
        return self.GetFrequencyDistributionCategoryReportResult(self.Sorting(), 0, 0).done(function (result) {
            if (result.Result == true) {
                self.AllModels(result.Models);
            }
        });
    };
    self.resetDefaults = function () {
        self.ReportLoaded(false);
        self.Models([]);
        self.AllModels([]);
        self.PageIndex(self.PageIndexDefault);
        self.PageSize(self.PageSizeDefault);
        self.TotalRows(0);
        self.Sorting([]);
    };
    self.Display = function () {
        parent.TabPage.IsLoading(true);
        self.resetDefaults();
        self.RefreshModels().done(function () {
            self.RefreshDiagramModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            }).fail(function () {
                self.ReportLoaded(false);
                parent.TabPage.IsLoading(false);
            });
        }).fail(function () {
            self.ReportLoaded(false);
            parent.TabPage.IsLoading(false);
        });
    };
    self.getFrequencyDistributionCategoryReportModel = function () {
        return Bao.post("Start/FrequencyDistributionCategoryGetReportModel", JSON.stringify({}));
    };
    self.init = function () {
        var def = $.Deferred();
        self.getFrequencyDistributionCategoryReportModel().done(function (result) {
            ko.map.fromJS(result, self);
            def.resolve();
        });
        def.done(function () {
            self.Initialized(true);
        });
        return def.promise();
    };
    self.MonthDayFormatter = function (dateToFormat) {
        if (dateToFormat.length == 1) {
            dateToFormat = "0" + dateToFormat;
        }
        return dateToFormat;
    };
    self.loaded = function () {
        self.ViewModel(new FrequencyDistributionCategoryModuleDiagramViewModel(self.TabPage, self.DiagramDataSet, self.DiagramTicks));
        self.Display();
    };
    self.DiagramTicks = ko.pureComputed(function () {
        var entries = self.AllModels();
        var result = [];
        if (entries.length > 0 && self.TagIsNumeric()) {
            for (var i in entries) {
                var x = Number(i) + 0;
                var label = ko.unwrap(entries[i].InsertDateHtml);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                label = label.substr(0, 10) + label.substr(10, 6);
                result.push([x, label]);
            }
        }
        return result;
    });
}
export default FrequencyDistributionCategoryReportViewModel;